import type { ProductVariant } from '~~/types/commercetools';
import type { RemoveFromCartTagDetailsParams } from '~~/types/integrations/tagManager/TagManagerIntegration';

export const useRemoveFromCartTagManager = () => {

  const { trackRemoveFromCart } = useGtmEvents();

  const triggerTags = (product: ProductVariant, details: RemoveFromCartTagDetailsParams) => {

    trackRemoveFromCart(
      product,
      {
        quantity: details.quantity,
        textDisplayed: details.textDisplayed,
        triggeredIn: details.triggeredIn,
        index: details.index,
      },
    );
  
  };

  return { triggerTags };

};
